export const suggestionsLoading = "nGGQHc";
export default {suggestionsLoading};